import type { SyncOption } from "../types/choose-sync"

export const CHOOSE_SYNC_CONSTANTS = {
  ROUTES: {
    CONNECT_ACCOUNTS: "/dashboard/connect-accounts",
    MAP_FIELDS: "/dashboard/map-fields",
  },
  STORAGE_KEYS: {
    SELECTED_SYNC_OPTION: "selectedSyncOption",
    CONNECTOR_FLOW_STEP: "connectorFlowStep",
  },
  ERROR_MESSAGES: {
    FETCH_FAILED: "Failed to load sync options",
    GENERIC_ERROR: "An unexpected error occurred",
  },
  STEP_INFO: {
    CURRENT_STEP: 3,
    COMPLETED_STEPS: [1, 2],
    STEP_LABEL: "Choose Sync",
  },
  SYNC_TYPES: {
    BIDIRECTIONAL: "Two-way sync",
    ONE_WAY: "One-way sync",
  },
  ENABLED_OBJECTS: ["contacts","companies","deals", "tickets"] as string[], // Explicitly type as string array
} as const

export const DEFAULT_SYNC_OPTIONS: SyncOption[] = [
  {
    id: "contacts-leads",
    name: "HubSpot Contacts → Salesforce Leads",
    description:
      "Sync and manage HubSpot Contacts as Salesforce Leads automatically to keep your sales data up-to-date across both platforms.",
    source_system: "HubSpot",
    source_object: "Contacts",
    target_system: "Salesforce",
    target_object: "Leads",
    supported_directions: "bidirectional",
    icon: null, // Will be set by icon generator
    isDisabled: false,
  },
  {
    id: "tasks",
    name: "HubSpot Tasks → Salesforce Tasks",
    description: "Sync and manage tasks between HubSpot and Salesforce to keep your activities aligned and up-to-date.",
    source_system: "HubSpot",
    source_object: "Tasks",
    target_system: "Salesforce",
    target_object: "Tasks",
    supported_directions: "one-way",
    icon: null, // Will be set by icon generator
    isDisabled: true, // Tasks are currently disabled
  },
]
